import { render, staticRenderFns } from "./RAGStorage.vue?vue&type=template&id=0baf0c8c&scoped=true&"
import script from "./RAGStorage.vue?vue&type=script&lang=js&"
export * from "./RAGStorage.vue?vue&type=script&lang=js&"
import style0 from "./RAGStorage.vue?vue&type=style&index=0&id=0baf0c8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf0c8c",
  null
  
)

export default component.exports